import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { APPLICATION_TYPE } from "tagTypes";

export const useApplicationTypeQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/application-type",
    query,
    tags: [APPLICATION_TYPE],
  });

export const useLazyApplicationTypeQuery = () => {
  const [getApplicationType, data] = useLazyGetQuery();
  const applicantType = async (query = {}) =>
    await getApplicationType(
      {
        endpoint: "/application-type",
        query,
        tags: [APPLICATION_TYPE],
      },
      true
    ).unwrap();
  return [applicantType, data];
};

export const usePostApplicationTypeMutation = () => {
  const [applicationType, data] = usePostMutation();
  const addApplicationType = async (payload, query = {}) =>
    await applicationType({
      endpoint: "/application-type",
      query,
      payload: payload || {},
      toastMessage: "Application type added successfully",
      tags: [APPLICATION_TYPE],
    }).unwrap();

  return [addApplicationType, data];
};

export const usePutApplicationTypeMutation = () => {
  const [applicationType, data] = usePutMutation();
  const updateApplicationType = async (payload, query = {}) =>
    await applicationType({
      endpoint: "/application-type",
      query,
      payload: payload || {},
      toastMessage: "Application type updated successfully",
      tags: [APPLICATION_TYPE],
    }).unwrap();
  return [updateApplicationType, data];
};

export const useDeleteApplicationTypeMutation = () => {
  const [applicationType, data] = useDeleteMutation();
  const deleteApplicationType = async (query = {}) =>
    await applicationType({
      endpoint: "/application-type",
      query,
      toastMessage: "Application type deleted successully",
      tags: [APPLICATION_TYPE],
    }).unwrap();
  return [deleteApplicationType, data];
};
